import React, { useEffect, useState } from 'react';
import { AnyIfEmpty, useDispatch, useSelector } from 'react-redux';
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom';
import Select, { SingleValue } from 'react-select';
import iconBack from '../../../images/icon-chevron-left.svg';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import { createVisitor, editVisitor, getvisitorListById } from '../../../redux/visitor-list/actions/visitor-list.action';
import Loader from '../../common/loader/Loader';
import styles from './createVisitorForm.module.css';
import eyeClose from '../../../images/icon-eye-close.svg';
import eyeOpen from '../../../images/icon-eye-open.svg';
import CustModal from '../../common/custmodal/CustModal';
import VisitorPopup from './visitorPopup';
import moment from 'moment';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import countriesData from '../../../constants/countries.json';
import {
    bedroomData,
    EditStateData,
    ErrorsObject,
    Location,
    MyObject,
    PhonenumberProps,
    VisitorObject,
    LeadSource
} from '../interface/Visitor.interface';
import { getLocation } from '../../../redux/location/actions/location.action';
import Toast from '../../common/toast/Toast';
import { getLeadSource } from '../../../redux/lead-sources/actions/leadSources.action';

const createVisitorForm: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate: NavigateFunction = useNavigate();

    const { id, type } = useLocation().state as EditStateData;

    const createdVisitor = useSelector((state: IRootState) => state.VisitorListReducer.createdVisitor.data);
    const editVisitorData = useSelector((state: IRootState) => state.VisitorListReducer.editVisitor.data);
    const loading = useSelector((state: IRootState) => state.VisitorListReducer.createdVisitor.loading);
    const editVisitorLoading = useSelector((state: IRootState) => state.VisitorListReducer.editVisitor.loading);
    const data = useSelector((state: IRootState) => state.VisitorListReducer.data.data);
    const userDataLoading = useSelector((state: IRootState) => state.VisitorListReducer.loading);
    const adminLocations = useSelector((state: IRootState) => state.locationReducer.data);

    const [leadSource, setLeadSource] = useState([])


    const leadSourceData = useSelector((state: IRootState) => state.leadSourceReducer.data);
    const leadSourceLoading = useSelector((state: IRootState) => state.leadSourceReducer.loading);

    const [showPass, setShowPass] = useState({
        pass: false,
        confirmPass: false,
    });
    const [errors, setErrors] = useState<ErrorsObject>({});
    const [showModalPopup, setShowModalPopup] = useState(false);
    const [locations, setLocations] = useState<Location[] | undefined>([]);
    const [isDateChanged, setIsDateChanged] = useState(false);

    const [phoneNumberObj, setPhoneNumberObj] = useState<PhonenumberProps>({
        number: '',
        contry: '',
        length: 11,
        countryCode: 'us',
        dialCode: '1',
        trimmedLength: 0,
    });

    const [visitorObj, setVisitorObj] = useState<VisitorObject>({
        firstName: data?.firstName || '',
        lastName: data?.lastName || '',
        phoneNumber: data?.phoneNumber || 0,
        email: data?.email || '',
        expectedMoveInDate: data?.expectedMoveInDate || '',
        password: data?.password || '',
        desiredNumBedrooms: { value: '', label: '' },
        confirmPassword: data?.password || '',
        leadProperty: { value: '', label: '' },
        leadPropertyLink: data?.leadPropertyLink,
        companyName: data?.companyName || '',
        pmsLeadSorce: {
            lead_name: data?.pmsLeadSorce?.lead_name || "",
            lead_id: data?.pmsLeadSorce?.lead_id || "",
            lead_PMS: data?.pmsLeadSorce?.lead_PMS || ""
        }
    });
    const [readOnly, setReadOnly] = useState(true);

    useEffect(() => {
        dispatch(getLocation());
    }, []);

    useEffect(() => {
        setLeadSource(leadSourceData.leadSources)
    }, [leadSourceData])


    useEffect(() => {
        id && dispatch(getvisitorListById(id));
    }, [id]);

    useEffect(() => {
        if (adminLocations && Object.keys(adminLocations).length) {
            const temp: Location[] = [];

            adminLocations.locations?.forEach((el: { name: string; id: string }) => {
                temp.push({ value: el.name, label: el.name, id: el.id });
            });

            adminLocations.locationinvitedlist?.forEach((el: { name: string; id: string }) => {
                temp.push({ value: el.name, label: el.name, id: el.id });
            });

            setLocations(temp);
        }
    }, [adminLocations]);

    useEffect(() => {
        const country = countriesData.data.find((el) => el.dial_code === `+${data?.countryCode}`);

        setPhoneNumberObj((prevState: PhonenumberProps) => {
            return {
                ...prevState,
                contry: data?.phoneNumber?.length + country?.dial_code.length,
                dialCode: country?.dial_code,
                countryCode: country?.code?.toLowerCase(),
            };
        });
    }, [data]);

    useEffect(() => {
        setVisitorObj({
            firstName: data?.firstName || '',

            lastName: data?.lastName || '',

            phoneNumber: data?.phoneNumber || 0,

            email: data?.email || '',

            expectedMoveInDate: data?.expectedMoveInDate
                ? moment(data?.expectedMoveInDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
                : '',

            password: data?.password || '',

            desiredNumBedrooms: {
                value: data?.desiredNumBedrooms
                    ? data?.desiredNumBedrooms === '0'
                        ? 'Studio'
                        : data?.desiredNumBedrooms.toString()
                    : null,
                label: data?.desiredNumBedrooms
                    ? data?.desiredNumBedrooms === '0'
                        ? 'Studio'
                        : data?.desiredNumBedrooms.toString()
                    : null,
            },

            confirmPassword: data?.password || '',

            leadProperty: {
                value: data?.locationName ? data?.locationName.toString() : null,
                label: data?.locationName ? data?.locationName.toString() : null,
            },

            leadPropertyLink: data?.leadPropertyLink,

            companyName: data?.companyName,
            pmsLeadSorce: {
                lead_id: data?.pmsLeadSorce?.lead_id || '',
                lead_name: data?.pmsLeadSorce?.lead_name || '',
                lead_PMS: data?.pmsLeadSorce?.lead_PMS || ''
            }
        });
    }, [data]);

    useEffect(() => {
        if (type === 'Add' && Object.keys(createdVisitor).length && createdVisitor.statusCode === 200) {
            setShowModalPopup(true);
        } else if (Object.keys(editVisitorData).length && editVisitorData.statusCode === 200) {
            navigate('/visitor');
        }
    }, [createdVisitor, type, editVisitorData]);

    const isValidDate = (dateString: string) => {
        const date = moment(dateString).format('YYYY-MM-DD');
        const dateFormat = 'YYYY-MM-DD';
        return moment(date, dateFormat, true).isValid();
    };

    const isValidPassword = (password: string) => {
        const passwordRegex = /^(?=.*[0-9])(?=.*[- ?!@#$%^&*\\])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@#$%^&*\\]{8,30}$/;
        return passwordRegex.test(password);
    };

    const isObjectEmpty = (obj: MyObject): boolean => {
        for (const key in obj) {
            if (obj[key] !== null) {
                return false;
            }
        }
        return true;
    };

    const validate = () => {
        const errors: ErrorsObject = {};
        const { firstName, email, lastName, password, phoneNumber, confirmPassword, expectedMoveInDate, leadProperty } = visitorObj;

        const trimmedFirstName = firstName.trim();
        const trimmedEmail = email.trim();
        const trimmedLastName = lastName.trim();

        if (!trimmedFirstName || !trimmedLastName || !trimmedEmail || !/\S+@\S+\.\S+/.test(trimmedEmail)) {
            if (!trimmedFirstName) {
                errors.firstName = 'First name is required';
            }
            if (!trimmedLastName) errors.lastName = 'Last name is required';
            if (!trimmedEmail) errors.email = 'Email is required';
            if (trimmedEmail && !/\S+@\S+\.\S+/.test(trimmedEmail)) errors.email = 'Email is invalid';
        }

        if (isObjectEmpty(leadProperty)) {
            errors.leadProperty = 'Lead property is required';
        }

        if (!phoneNumber) {
            errors.phoneNumber = 'Phone number is required';
        } else if (
            phoneNumber.toString().length !==
            Number(phoneNumberObj?.contry) - (phoneNumberObj.dialCode ? phoneNumberObj.dialCode.length : 0)
        ) {
            errors.phoneNumber = `Phone number must be ${Number(phoneNumberObj?.contry) - (phoneNumberObj.dialCode ? phoneNumberObj.dialCode.length : 0)
                } digits long`;
        }

        if (expectedMoveInDate && isDateChanged && expectedMoveInDate < today) {
            errors.expectedMoveInDate = 'Date Must Be Today or Later';
        }

        if (type === 'Add' && !password.trim()) {
            errors.password = 'Password cannot be empty';
        } else if (type === 'Add' && !isValidPassword(password)) {
            errors.password = 'Password must contain numbers, uppercase, letters, at least one special character, must be 8 characters';
        }

        if (type === 'Add' && password !== confirmPassword) {
            errors.confirmPassword = 'Password does not match';
        }
        if (expectedMoveInDate && !isValidDate(expectedMoveInDate)) {
            errors.expectedMoveInDate = 'Invalid date';
        }
        return errors;
    };

    const submitHandler = (e: React.FormEvent) => {
        e.preventDefault();

        const { confirmPassword, leadProperty, ...rest } = visitorObj;
        const desiredNumBedrooms = visitorObj.desiredNumBedrooms.label;
        const phoneNumber = Number(visitorObj.phoneNumber);

        const errors: ErrorsObject = validate();

        if (Object.keys(errors).length) {
            setErrors(errors);
        } else {
            setErrors({});
            if (type === 'Edit') {
                dispatch(
                    editVisitor(id, {
                        ...rest,
                        // desiredNumBedrooms: visitorObj.desiredNumBedrooms.label,
                        desiredNumBedrooms: desiredNumBedrooms === 'Studio' ? '0' : desiredNumBedrooms,
                        // phoneNumber: Number(visitorObj.phoneNumber),
                        phoneNumber,
                        countryCode: Number(phoneNumberObj.dialCode),
                        expectedMoveInDate: visitorObj.expectedMoveInDate
                            ? moment(visitorObj.expectedMoveInDate).format('YYYY-MM-DD')
                            : null,
                    }),
                );
            } else {
                dispatch(
                    createVisitor({
                        ...rest,
                        desiredNumBedrooms: visitorObj.desiredNumBedrooms.label === 'Studio' ? '0' : visitorObj.desiredNumBedrooms.label,
                        countryCode: Number(phoneNumberObj.dialCode),
                        leadPropertyLink: visitorObj.leadPropertyLink,
                    }),
                );
            }
        }
    };

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        name === 'expectedMoveInDate' && setIsDateChanged(true);

        if (name === 'firstName' || name === 'lastName') {
            setVisitorObj((prevState) => {
                return {
                    ...prevState,
                    [name]: value.replace(/[^a-zA-Z\s]/g, ''),
                };
            });
        } else {
            setVisitorObj((prevState) => ({
                ...prevState,
                [name]: name === 'phoneNumber' ? Number(value) : value,
            }));
        }
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>, fieldName: keyof VisitorObject) => {
        if (event.key === ' ' && String(visitorObj[fieldName]).length === 0) {
            event.preventDefault();
        }
    };

    const today = new Date().toISOString().split('T')[0];

    const phoneNumberHandler = (evt: any, country: any) => {
        const tempArr = { ...errors };
        delete tempArr.phoneNumber;
        setErrors(tempArr);

        phoneNumberObj.countryCode !== country.countryCode &&
            setVisitorObj((prevState) => {
                return {
                    ...prevState,
                    phoneNumber: 0,
                };
            });

        setPhoneNumberObj({
            number: evt.length,
            contry: country?.format?.match(/\./g)?.length,
            length: country.format.length,
            countryCode: country.countryCode,
            dialCode: country.dialCode,
            trimmedLength: country?.format?.replace(/ /g, '')?.length,
        });

        const number = evt.slice(country?.dialCode?.length);

        setVisitorObj((prevState) => {
            return {
                ...prevState,
                phoneNumber: Number(number),
            };
        });
    };

    useEffect(() => {
        if (visitorObj.leadPropertyLink) {
            dispatch(getLeadSource(visitorObj.leadPropertyLink))
        }
    }, [visitorObj.leadPropertyLink])

    return (
        <>
            {createdVisitor.statusCode === 400 && <Toast message={createdVisitor.message} />}
            {loading || editVisitorLoading || userDataLoading ? (
                <Loader />
            ) : (
                <form onSubmit={submitHandler} noValidate>
                    <div className={'outletConainer'}>
                        <div className={styles.inlineItems}>
                            <div className={styles.leftSection}>
                                <div onClick={() => navigate('/visitor')} className={styles.backButton}>
                                    <img src={iconBack} alt="back icon" />
                                </div>
                                <h2>{type === 'Add' ? 'Create A Visitor' : 'Edit Information'} </h2>
                            </div>
                            <div className={styles.btnContainer}>
                                {type === 'Edit' && (
                                    <button onClick={() => navigate('/visitor')} type="button" className={styles.btnWhite}>
                                        Cancel
                                    </button>
                                )}
                                <button type="submit" className={styles.btnGreen}>
                                    {type === 'Add' ? 'Create' : 'Save'}
                                </button>
                            </div>
                        </div>
                        <div className={styles.visitorForm}>
                            <div className={styles.inputContainer}>
                                <div className={styles.formWrapper}>
                                    <label>
                                        First Name <sup>*</sup>
                                    </label>
                                    <input
                                        onKeyPress={(e) => handleKeyPress(e, 'firstName')}
                                        onChange={onChangeHandler}
                                        type="text"
                                        name="firstName"
                                        placeholder="Enter visitor first name"
                                        value={visitorObj.firstName}
                                    />
                                    {errors.firstName && <span className={styles.error}>{errors.firstName}</span>}
                                </div>

                                <div className={styles.formWrapper}>
                                    <label>
                                        Last Name <sup>*</sup>
                                    </label>
                                    <input
                                        onKeyPress={(e) => handleKeyPress(e, 'lastName')}
                                        onChange={onChangeHandler}
                                        type="text"
                                        name="lastName"
                                        placeholder="Enter visitor last name"
                                        value={visitorObj.lastName}
                                    />
                                    {errors.lastName && <span className={styles.error}>{errors.lastName}</span>}
                                </div>

                                <div className={styles.formWrapper}>
                                    <label>
                                        Visitor Email <sup>*</sup>
                                    </label>
                                    <input
                                        readOnly={readOnly}
                                        onFocus={() => setReadOnly(false)}
                                        onBlur={() => setReadOnly(false)}
                                        disabled={type === 'Edit'}
                                        onKeyPress={(e) => handleKeyPress(e, 'email')}
                                        onChange={(e) => (type !== 'Edit' ? onChangeHandler(e) : e.stopPropagation())}
                                        type="text"
                                        name="email"
                                        placeholder="Enter visitor email"
                                        value={visitorObj.email}
                                    />
                                    {errors.email && <span className={styles.error}>{errors.email}</span>}
                                </div>

                                <div className={`${styles.formWrapper} phoneInputWrapper`}>
                                    <label>
                                        Phone Number <sup>*</sup>
                                    </label>

                                    {((type === 'Edit' && phoneNumberObj?.dialCode) || type === 'Add') && (
                                        <PhoneInput
                                            country={phoneNumberObj.countryCode}
                                            value={String(`+${phoneNumberObj.dialCode}${visitorObj.phoneNumber || ''}`)}
                                            onChange={phoneNumberHandler}
                                            inputStyle={{
                                                marginLeft: '30px',
                                            }}
                                            enableSearch
                                            inputProps={{ maxLength: phoneNumberObj.length, autoFocus: true }}
                                            countryCodeEditable={true}
                                            enableLongNumbers={true}
                                            prefix='+'
                                        />
                                    )}
                                    {errors.phoneNumber && <span className={styles.error}>{errors.phoneNumber}</span>}
                                </div>

                                <div className={styles.formWrapper}>
                                    <label>Desired Move In Date, If Applicable</label>
                                    <input
                                        onKeyPress={(e) => handleKeyPress(e, 'expectedMoveInDate')}
                                        onChange={(e) => {
                                            onChangeHandler(e);
                                        }}
                                        type="date"
                                        name="expectedMoveInDate"
                                        max="9999-12-31"
                                        placeholder="YYYY-MM-DD"
                                        value={visitorObj.expectedMoveInDate || ''}
                                        min={today}
                                    />
                                </div>

                                <div className={styles.formWrapper}>
                                    <label>Desired Number of Bedrooms, If Applicable</label>

                                    <Select
                                        placeholder="Select desired number of bedrooms"
                                        onChange={(evt) =>
                                            setVisitorObj((prevState: AnyIfEmpty<object>) => {
                                                return {
                                                    ...prevState,
                                                    desiredNumBedrooms: evt,
                                                };
                                            })
                                        }
                                        options={bedroomData}
                                        value={visitorObj.desiredNumBedrooms?.value === null ? '' : visitorObj?.desiredNumBedrooms}
                                        className={styles.customSelect}
                                        components={{
                                            IndicatorSeparator: () => null,
                                        }}
                                        styles={{
                                            control: () => ({
                                                padding: '2px 10px 2px 21px',
                                                height: '48px',
                                                display: 'flex',
                                                border: '1px solid #D1D2D3',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                lineHeight: '28px',
                                            }),
                                            placeholder: (styles) => ({
                                                ...styles,
                                                color: '#B2B3B5',
                                            }),
                                        }}
                                    />
                                </div>
                                <div className={styles.inlineInputs}>
                                    <div className={styles.formWrapper}>
                                        <label>
                                            Property/Community Name <sup>*</sup>
                                        </label>

                                        <Select
                                            placeholder="Select property/community name"
                                            classNamePrefix="react-select"
                                            onChange={(evt: AnyIfEmpty<object>) => {
                                                if (evt?.id !== visitorObj?.leadPropertyLink) {
                                                    setVisitorObj((prevState: AnyIfEmpty<object>) => {
                                                        return {
                                                            ...prevState,
                                                            leadPropertyLink: evt.id,
                                                            leadProperty: evt,
                                                            pmsLeadSorce: {
                                                                lead_id: '',
                                                                lead_name: '',
                                                                lead_PMS: ''
                                                            }
                                                        };
                                                    })
                                                }
                                            }
                                            }
                                            options={locations}
                                            value={visitorObj.leadProperty?.value === null ? '' : visitorObj?.leadProperty}
                                            className={styles.customSelect}
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                            styles={{
                                                control: () => ({
                                                    padding: '2px 10px 2px 21px',
                                                    height: '48px',
                                                    display: 'flex',
                                                    border: '1px solid #D1D2D3',
                                                    borderRadius: '8px',
                                                    fontSize: '14px',
                                                    lineHeight: '28px',
                                                }),
                                                placeholder: (styles) => ({
                                                    ...styles,
                                                    color: '#B2B3B5',
                                                }),
                                            }}
                                        />

                                        {errors.leadProperty && <span className={styles.error}>{errors.leadProperty}</span>}
                                    </div>

                                    <div className={styles.formWrapper}>
                                        <label>How did you hear about us?</label>

                                        <Select
                                            placeholder="Select source"
                                            onChange={(newValue: SingleValue<LeadSource>) => {
                                                if (newValue) {
                                                    setVisitorObj((prevState: AnyIfEmpty<object>) => {
                                                        return {
                                                            ...prevState,
                                                            pmsLeadSorce: {
                                                                lead_id: newValue.lead_id,
                                                                lead_name: newValue.lead_name,
                                                                lead_PMS: newValue.lead_PMS
                                                            },
                                                        };
                                                    })
                                                }
                                            }}
                                            isLoading={leadSourceLoading}
                                            options={visitorObj?.leadPropertyLink !== undefined ? leadSource?.map((source: { lead_id: string, lead_PMS: string, lead_name: string }) => {
                                                return {
                                                    value: source.lead_id + " " + source.lead_name,
                                                    label: source.lead_name,
                                                    ...source
                                                }
                                            }) : []}
                                            value={visitorObj?.pmsLeadSorce?.lead_name !== '' ? {
                                                label: (leadSource?.find((source: any) => source?.lead_name === visitorObj?.pmsLeadSorce?.lead_name && source?.lead_id === visitorObj?.pmsLeadSorce?.lead_id) as any)?.lead_name,
                                                value: (leadSource?.find((source: any) => source?.lead_name === visitorObj?.pmsLeadSorce?.lead_name && source?.lead_id === visitorObj?.pmsLeadSorce?.lead_id) as any)?.lead_id + " " + (leadSource?.find((source: any) => source?.lead_name === visitorObj?.pmsLeadSorce?.lead_name && source?.lead_id === visitorObj?.pmsLeadSorce?.lead_id) as any)?.lead_name,
                                                lead_id: (leadSource?.find((source: any) => source?.lead_name === visitorObj?.pmsLeadSorce?.lead_name && source?.lead_id === visitorObj?.pmsLeadSorce?.lead_id) as any)?.lead_id,
                                                lead_name: (leadSource?.find((source: any) => source?.lead_name === visitorObj?.pmsLeadSorce?.lead_name && source?.lead_id === visitorObj?.pmsLeadSorce?.lead_id) as any)?.lead_name,
                                                lead_PMS: (leadSource?.find((source: any) => source?.lead_name === visitorObj?.pmsLeadSorce?.lead_name && source?.lead_id === visitorObj?.pmsLeadSorce?.lead_id) as any)?.lead_PMS
                                            } : null}
                                            className={styles.customSelect}
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                            styles={{
                                                control: () => ({
                                                    padding: '2px 10px 2px 21px',
                                                    height: '48px',
                                                    display: 'flex',
                                                    border: '1px solid #D1D2D3',
                                                    borderRadius: '8px',
                                                    fontSize: '14px',
                                                    lineHeight: '28px',
                                                }),
                                                placeholder: (styles) => ({
                                                    ...styles,
                                                    color: '#B2B3B5',
                                                }),
                                            }}
                                        />
                                    </div>

                                    <div className={styles.formWrapper}>
                                        <label>Company/Organization</label>
                                        <input
                                            onKeyPress={(e) => handleKeyPress(e, 'companyName')}
                                            onChange={(e) => {
                                                onChangeHandler(e);
                                            }}
                                            type="text"
                                            name="companyName"
                                            value={visitorObj.companyName || ''}
                                            placeholder="Enter company/organization name"
                                        />
                                    </div>

                                    {type === 'Add' && (
                                        <>
                                            <div className={styles.inputWrapper}>
                                                <label>
                                                    Visitor Password <sup>*</sup>
                                                </label>
                                                <div className={styles.passwordWrapper}>
                                                    <input
                                                        type={showPass.pass ? 'text' : 'password'}
                                                        name="password"
                                                        onChange={onChangeHandler}
                                                        placeholder="Add 8 digit strong password"
                                                        value={visitorObj.password}
                                                    />
                                                    <div
                                                        className={styles.eyeToggler}
                                                        onClick={() => setShowPass({ ...showPass, pass: !showPass.pass })}>
                                                        <img src={!showPass.pass ? eyeClose : eyeOpen} alt="Eye" />
                                                    </div>
                                                </div>
                                                {errors.password && <span className={styles.error}>{errors.password}</span>}
                                            </div>

                                            <div className={styles.inputWrapper}>
                                                <label>
                                                    Confirm Visitor Password <sup>*</sup>
                                                </label>
                                                <div className={styles.passwordWrapper}>
                                                    <input
                                                        type={showPass.confirmPass ? 'text' : 'password'}
                                                        name="confirmPassword"
                                                        onChange={onChangeHandler}
                                                        placeholder="Add 8 digit strong password"
                                                        value={visitorObj.confirmPassword}
                                                    />
                                                    <div
                                                        className={styles.eyeToggler}
                                                        onClick={() => setShowPass({ ...showPass, confirmPass: !showPass.confirmPass })}>
                                                        <img src={!showPass.confirmPass ? eyeClose : eyeOpen} alt="Eye" />
                                                    </div>
                                                </div>
                                                {errors.confirmPassword && <span className={styles.error}>{errors.confirmPassword}</span>}
                                            </div>
                                        </>
                                    )}
                                </div>


                            </div>

                            {showModalPopup && (
                                <CustModal
                                    open={showModalPopup}
                                    setOpen={() => setShowModalPopup(!showModalPopup)}
                                    navigateURL="/visitor"
                                    bodyData={
                                        <VisitorPopup
                                            title={'Visitor has been added!'}
                                            message={'Login information has been sent to visitor on registered email address'}
                                            setShowModalPopup={setShowModalPopup}
                                        />
                                    }
                                    className="visitor-modal-popup"
                                />
                            )}
                        </div>
                    </div>
                </form>
            )}
            ;
        </>
    );
};

export default createVisitorForm;
